import React, { useEffect, useState } from "react";
import BackButton from "./BackButton";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./MyPlanModal.css";
import { useAuth } from "../contexts/AuthContext";

const MyPlanModal = ({ onClose }) => {
  const { encryptedData } = useAuth(); // Use encrypted data from AuthContext
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      setLoading(true);
      try {
        const payload = {
          // member_id: localStorage.getItem("member/member_id"),
          // uid: localStorage.getItem("member/uid"),
          // updated_at: localStorage.getItem("member/updated_at"),
          // optcode: localStorage.getItem("member/optcode"),
          data: encryptedData
        };

        const formData = new FormData();
        Object.keys(payload).forEach((key) => formData.append(key, payload[key]));

        const response = await axios.post(`${BASE_URL}/x1bf/x1wh/member/plan`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
          },
        });

        if (response.data.status === "success") {
          setPlans(response.data.data);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: "#ef4444",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to fetch plans.",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#ef4444",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const renderTableRows = () => {
    return plans.map((plan) => (
      <tr key={plan.plan_code}>
        <td>{plan.plan_name || "N/A"}</td>
        {/* <td>{formatDate(plan.effective_date)}</td> */}
        {/* <td>{formatDate(plan.expiry_date)}</td> */}
      </tr>
    ));
  };
  const renderTableHeader = () => (
    <tr>
      <th>Plan Name</th>
      {/* <th>Effective Date</th> */}
      {/* <th>Expiry Date</th> */}
    </tr>
  );

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-backrow"><BackButton onClick={onClose} /></div>
          <h1 className="modal-title">My Plan Details</h1>
          <button onClick={onClose} className="modal-close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="loading-spinner">
              <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
            </div>
          ) : (
            <div className="table-container">
              <table className="transaction-table">
                <thead>{renderTableHeader()}</thead>
                <tbody>
                  {plans.length > 0 ? (
                    renderTableRows()
                  ) : (
                    <tr>
                      <td colSpan="3" className="no-data">
                        No plans found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          <div className="modal-footer">
            <button onClick={onClose} className="modal-close-text-btn">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPlanModal;